import { useLogger } from "@1js/pl-logger";
import { Skeleton, SkeletonItem, TabList } from "@fluentui/react-components";
import React from "react";
import { BookmarkTab } from "./BookmarkTab";
import { GroupTab } from "./GroupTab";
import { SuggestedTab } from "./SuggestedTab";
export type PromptTabs = "AllPrompts" | "SavedPrompts" | "GroupPrompts";

export type PromptTabProps = {
  loading?: boolean;
  isShowGroupTab?: boolean;
  isShowSavedTab?: boolean;
  selectedValue?: PromptTabs;
  onTabSelected?: (selectedTab: PromptTabs) => void;
};

export const PromptTab: React.FC<PromptTabProps> = React.memo(
  ({
    loading,
    selectedValue,
    isShowSavedTab = true,
    isShowGroupTab,
    onTabSelected,
  }) => {
    const logger = useLogger();

    const handleOnTabSelect = React.useCallback(
      (value: PromptTabs) => {
        if (value === "SavedPrompts") {
          logger?.promptLibrary.sendResultsRenderedEvent({
            metaData: {
              eventId: "Bookmarked",
            },
          });
        }

        onTabSelected && onTabSelected(value);
      },
      [onTabSelected, logger]
    );

    return loading ? (
      <Skeleton>
        <SkeletonItem size={32} style={{ width: "160px", marginLeft: "6px" }} />
      </Skeleton>
    ) : (
      <TabList
        selectedValue={selectedValue}
        onTabSelect={(_, selectedTab) =>
          handleOnTabSelect(selectedTab.value as PromptTabs)
        }
      >
        <SuggestedTab />
        {isShowSavedTab && <BookmarkTab />}
        {isShowGroupTab && <GroupTab />}
      </TabList>
    );
  }
);

PromptTab.displayName = "PromptTab";
